export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-clipboard-notes-6089f7b7761f3f86d4bf1f8b2d420e19.svg";